export const roleDataConstants = [
  "accountant",
  "super-admin",
  "bs-supervisor",
  "bs-admin",
];

export const DESTINATIONS = {
  USER_DETAILS: "USER_DETAILS",
  CATEGORY_DETAILS: "CATEGORY_DETAILS",
  BANNER_DETAILS: "BANNER_DETAILS",
  BLOG_DETAILS: "BLOG_DETAILS",
};
